import { getEnv } from '@/utils/envHelpers';

const ENV = getEnv();

export default ENV;
